module.exports = __webpack_public_path__ + "static/img/bg-tr.d5dede5e.png";